import { motion } from "framer-motion";
import RevealText from "../components/RevealText";
import { processSteps } from "../lib/data";

export default function Process() {
  return (
    <div data-testid="page-process" className="pt-[calc(var(--site-header-offset)+2rem)] md:pt-40">
      <section className="px-6 md:px-12 pb-16 md:pb-24">
        <p className="font-body uppercase text-xs tracking-[0.2em] text-black/50 mb-6">Process — 5 stages</p>
        <h1 className="font-display uppercase text-[18vw] md:text-[14vw] leading-[0.86] tracking-mega">
          <RevealText>How a</RevealText><br/>
          <RevealText delay={0.06}><em className="font-editorial italic">story</em> gets</RevealText><br/>
          <RevealText delay={0.12}>made.</RevealText>
        </h1>
      </section>

      <section className="px-6 md:px-12 pb-10 md:pb-16" data-testid="process-steps">
        {processSteps.map((s, i) => (
          <motion.article
            key={s.n}
            initial={{ opacity: 0, y: 80 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
            className={`border-t border-black/15 grid grid-cols-12 gap-6 items-start ${i === processSteps.length - 1 ? "pt-10 md:pt-16 pb-0" : "py-10 md:py-16"}`}
            data-testid={`process-step-${s.n}`}
          >
            <div className="col-span-12 md:col-span-2">
              <span className="font-body uppercase text-xs tracking-[0.2em] text-black/50">Step {s.n}</span>
            </div>
            <div className="col-span-12 md:col-span-6">
              <h2 className="font-display uppercase text-6xl md:text-[10vw] tracking-mega leading-[0.86]">{s.name}<span className="text-[#F42B29]">.</span></h2>
            </div>
            <div className="col-span-12 md:col-span-4">
              <p className="font-body text-lg md:text-xl text-black/75 max-w-md">{s.text}</p>
            </div>
          </motion.article>
        ))}
      </section>

      <section className="px-6 md:px-12 pt-12 pb-16 md:pt-16 md:pb-24 bg-[#FC9603]">
        <h2 className="font-display text-5xl md:text-8xl uppercase tracking-mega leading-[0.88]">
          <RevealText>Five steps,</RevealText><br/>
          <RevealText delay={0.06}>one obsession<span className="text-white">.</span></RevealText>
        </h2>
        <p className="mt-8 max-w-xl font-body text-lg md:text-xl text-black/80">
          We don&apos;t shortcut. We don&apos;t skip discovery. We don&apos;t farm out the edit. Every step happens in-house, by people who care a bit too much.
        </p>
      </section>
    </div>
  );
}
